<div
  class="fixed inset-0 z-[9999] flex items-center justify-center bg-white/70 backdrop-blur-md"
>
  <div class="flex flex-col items-center gap-4">
    <hlm-spinner />
    @if (message) {
      <p class="text-lg font-medium text-gray-700">{{ message }}</p>
    }
    @if (subMessage) {
      <p class="text-sm text-gray-500">{{ subMessage }}</p>
    }
  </div>
</div>
